module.exports = __webpack_public_path__ + "img/DSC_7060.054b2e2a.jpg";